module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clickSearch]
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n            " + _vm._s(brand.label) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clickSearch]
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n            " + _vm._s(store.label) + "\n          ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("訂購總人數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.shopper_count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交訂單數量")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.order_count_total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交訂單金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.order_money_total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交商品數量")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.platformMoney.item_count_total))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body p-0 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 text-left"
  }, [_c('div', {
    staticClass: "m-b-15"
  }, [_c('ion-icon', {
    attrs: {
      "name": "list-box"
    }
  }), _vm._v(" 期間內成交訂單數量： " + _vm._s(_vm.platformMoney.order_count_seg) + " 筆"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "ion ion-cash"
  }), _vm._v(" 期間內成交訂單金額： " + _vm._s(_vm.platformMoney.order_money_seg) + " 元"), _c('br'), _vm._v(" "), _c('ion-icon', {
    attrs: {
      "name": "restaurant"
    }
  }), _vm._v(" 期間內成交商品數量： " + _vm._s(_vm.platformMoney.item_count_seg) + " 份\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("使用者")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "th-fit c-pointer",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('shopper_id')
      }
    }
  }, [_vm._v("ID\n                "), (_vm.sortMethod === 'shopper_id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "list-box"
    }
  }), _vm._v(" 成交訂單數")], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "restaurant"
    }
  }), _vm._v(" 成交商品數")], 1), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('order_count_seg')
      }
    }
  }, [_vm._v("期間\n                "), (_vm.sortMethod === 'order_count_seg') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('order_count_total')
      }
    }
  }, [_vm._v("累積\n                "), (_vm.sortMethod === 'order_count_total') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('money_seg')
      }
    }
  }, [_vm._v("期間\n                "), (_vm.sortMethod === 'money_seg') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('money_total')
      }
    }
  }, [_vm._v("累積\n                "), (_vm.sortMethod === 'money_total') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('item_count_seg')
      }
    }
  }, [_vm._v("期間\n                "), (_vm.sortMethod === 'item_count_seg') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "th-fit c-pointer",
    on: {
      "click": function($event) {
        return _vm.checkSort('item_count_total')
      }
    }
  }, [_vm._v("累積\n                "), (_vm.sortMethod === 'item_count_total') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(5)]) : (_vm.shopperMoneyList.length === 0) ? _c('tbody', [_vm._m(6)]) : (_vm.shopperMoneyList.length > 0) ? _c('tbody', _vm._l((_vm.shopperMoneyList), function(shopper, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/memberOrderTable/' + shopper.shopper_id,
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(shopper.user_no) + "\n                    | " + _vm._s(shopper.nickname) + "\n                    "), (shopper.last_name || shopper.first_name) ? _c('span', [_vm._v(" (" + _vm._s(shopper.last_name) + _vm._s(shopper.first_name) + ")")]) : _vm._e()])], 1), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(shopper.shopper_id))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.order_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.order_count_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.money_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.money_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.item_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.item_count_total))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#shopperMoneyModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(shopper)
        }
      }
    }, [_c('i', {
      staticClass: "ion ion-cash"
    })])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(10)])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperMoneyModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.shopperInfo.nickname) + "消費統計")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable text-center",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "list-box"
    }
  }), _vm._v(" 成交訂單數")], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ion-icon', {
    attrs: {
      "name": "restaurant"
    }
  }), _vm._v(" 成交商品數")], 1)]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.shopperInfo.order_count_seg) + " / " + _vm._s(_vm.platformMoney.order_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.order_count_total) + " / " + _vm._s(_vm.platformMoney.order_count_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.money_seg) + " / " + _vm._s(_vm.platformMoney.order_money_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.money_total) + " / " + _vm._s(_vm.platformMoney.order_money_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.item_count_seg) + " / " + _vm._s(_vm.platformMoney.item_count_seg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shopperInfo.item_count_total) + " / " + _vm._s(_vm.platformMoney.item_count_total))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.order_count_seg, _vm.platformMoney.order_count_seg) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.order_count_seg, _vm.platformMoney.order_count_seg)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.order_count_total, _vm.platformMoney.order_count_total) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.order_count_total, _vm.platformMoney.order_count_total)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.money_seg, _vm.platformMoney.order_money_seg) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.money_seg, _vm.platformMoney.order_money_seg)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.money_total, _vm.platformMoney.order_money_total) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.money_total, _vm.platformMoney.order_money_total)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.item_count_seg, _vm.platformMoney.item_count_seg) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.item_count_seg, _vm.platformMoney.item_count_seg)) + "％")]), _vm._v(" "), _c('td', {
    class: {
      'text-red': _vm.getPercent(_vm.shopperInfo.item_count_total, _vm.platformMoney.item_count_total) > 0.01
    }
  }, [_vm._v(_vm._s(_vm.getPercent(_vm.shopperInfo.item_count_total, _vm.platformMoney.item_count_total)) + "％")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-ios-people"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-document-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-light-blue"
  }, [_c('i', {
    staticClass: "ion ion-wineglass"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_c('i', {
    staticClass: "ion ion-cash"
  }), _vm._v(" 成交訂單金額")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('i', {
    staticClass: "ion ion-cash"
  }), _vm._v(" 成交訂單金額")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("期間")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("累積")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("期間")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("累積")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("期間")]), _vm._v(" "), _c('th', {
    staticClass: "c-pointer"
  }, [_vm._v("累積")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a501b66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/Temp/ShopperMoneyTableTemp.vue
// module id = 2407
// module chunks = 1